import {
  getAllProviderUsers,
  getAllProviderUsersByProviderId,
  getAllSponsorUserList,
  getAllSponsorUsersList,
} from "../api/api-methods";
import { getCatalogUserTableFilters } from "./teamUsersTable";
import { hasJoinedProviderUser } from "./requestContactDesignations";

export const TEAM_USERS_CATALOG_PAGE_SIZE = 200;

export function resolvePaginatedTotal(page) {
  return page?.total_items ?? page?.total_count;
}

export function resolveOrgTeamSize({
  isVendorView,
  catalogItems,
  isCatalogLoaded,
  catalogTotalUsers,
  tableTotalUsers,
}) {
  if (isVendorView) {
    return isCatalogLoaded ? catalogItems.filter(hasJoinedProviderUser).length : undefined;
  }
  return typeof catalogTotalUsers === "number" ? catalogTotalUsers : tableTotalUsers;
}

/** Unfiltered catalog page for a single sponsor org team list. */
export function fetchSponsorOrgUsersCatalogPage(orgId, page, isVendorContext = false) {
  return getAllSponsorUserList({
    currentPage: page,
    id: orgId,
    search_text: "",
    page_size: TEAM_USERS_CATALOG_PAGE_SIZE,
    filters: getCatalogUserTableFilters(isVendorContext),
  });
}

/** Unfiltered catalog page for Admin → Sponsors → Users. */
export function fetchSponsorUsersAdminCatalogPage(page) {
  return getAllSponsorUsersList({
    currentPage: page,
    userSearchQuery: "",
    pageSize: TEAM_USERS_CATALOG_PAGE_SIZE,
    filters: getCatalogUserTableFilters(false),
  });
}

/** Unfiltered catalog page for Admin → Vendors → Users. */
export function fetchProviderUsersAdminCatalogPage(page) {
  return getAllProviderUsers(
    TEAM_USERS_CATALOG_PAGE_SIZE,
    page,
    "",
    undefined,
    getCatalogUserTableFilters(true)
  );
}

/** Unfiltered catalog page for a single vendor org team list. */
export function fetchProviderOrgUsersCatalogPage(providerId, page) {
  return getAllProviderUsersByProviderId(
    providerId,
    TEAM_USERS_CATALOG_PAGE_SIZE,
    page,
    "",
    undefined,
    getCatalogUserTableFilters(true)
  );
}

/** Unfiltered catalog page for Manage Account → Team (sponsor or vendor org). */
export function fetchOrgTeamUsersCatalogPage(
  { isVendorView, vendorId, sponsorId },
  page
) {
  if (isVendorView) {
    return fetchProviderOrgUsersCatalogPage(vendorId, page);
  }
  return fetchSponsorOrgUsersCatalogPage(sponsorId, page, false);
}
